/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Tab_StandardsInputs */



/**
* | output |
* | --- |
* | "Standards" |
*
* @param {Preset_Manager_Tab_StandardsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_tab_standards = /** @type {((inputs?: Preset_Manager_Tab_StandardsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Tab_StandardsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Standards")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standards")
	if (locale === "it") return /** @type {LocalizedString} */ ("Standards")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Standards")
	if (locale === "es") return /** @type {LocalizedString} */ ("Standards")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Standards")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Standards")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Standards")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Standards")
	return /** @type {LocalizedString} */ ("Standards")
});